import React from "react";
import tw, { styled } from 'twin.macro';
import { css } from "styled-components/macro"; //eslint-disable-line

const HighlightSpan = styled.span`
  ${tw`font-semibold`}
`;

const defaultContent = {
    pageInfo: {
        locationString: "/devcommunity/",
        description: "Gunbot Dev Community, a marketplace for crypto bots built by community members. Learn more about developing on the Gunbot platform.",
        title: "Gunbot Dev Community"
    },
    devCommunity: {
        hero: {
            heading: "Dev Community",
            description: "Explore projects built by community members and learn about developing custom trading bots for the Gunbot platform.",
            ctaButton: "Get Started",
            chipText: "New"
        },
        why: {
            description: <>Realize your own advanced trading algorithms. Gunbot offers <HighlightSpan>extensive API integrations</HighlightSpan> and powerful customization options. Run your own code directly in Gunbot on your <HighlightSpan>secure local environment</HighlightSpan>. From novel indicators to sophisticated trade execution: if you can code it, you can trade it with Gunbot.</>,
        },
        communityProjects: {
            heading: "Featured User Projects",
            subheading: "Explore custom crypto trading bots offered by some of our community devs.",
            projects: [
                {
                    title: "MachineGun",
                    description: "Subpercentage trading strategy for continual accumulation.",
                    link: "/devcommunity/machinegun/",
                    category: "AutoConfig Setup",
                    linkText: "Learn More"
                },
                {
                    title: "Broxynet-V1",
                    description: "Trading modes optimized for returns with reduced risk.",
                    link: "/devcommunity/broxynet/",
                    category: "Custom Strategy",
                    linkText: "Learn More"
                },
                {
                    title: "ChannelMaestro",
                    description: "Allround trading strategy, deploy in under 10 seconds.",
                    link: "/devcommunity/channelmaestro/",
                    category: "Custom Strategy",
                    linkText: "Learn More"
                },
                {
                    title: "Quanta ExoTrader",
                    description: "Data science trading with capital efficiency and precision.",
                    link: "/devcommunity/quantaexotrader/",
                    category: "Custom Strategy",
                    linkText: "Learn More"
                },
                {
                    title: "GTREND Spot",
                    description: "Hit uptrends, preserve assets on downtrends.",
                    link: "/devcommunity/gtrendspot/",
                    category: "Custom Strategy",
                    linkText: "Learn More"
                },
                {
                    title: "GTREND Futures",
                    description: "Leverage market movements with advanced algorithms.",
                    link: "/devcommunity/gtrendfutures/",
                    category: "Custom Strategy",
                    linkText: "Learn More"
                },
                {
                    title: "Marketplace (legacy)",
                    description: "Archive of old marketplace with mostly autoconfig setups.",
                    link: "https://www.gunbot.com/devcommunity/marketplace-archive/",
                    category: "Archive",
                    linkText: "Learn More"
                },
                {
                  title: "ExpectedMove",
                  description: "Power Law driven spot trading strategy",
                  link: "/devcommunity/expectedmove/",
                  category: "Custom Strategy",
                  linkText: "Learn More"
              },
              {
                title: "MFRider",
                description: "Ride the Market Wave with Precision",
                link: "/devcommunity/mfrider/",
                category: "Custom Strategy",
                linkText: "Learn More"
            },
            ]

        },
        resources: {
            heading: "Developer Resources",
            subheading: "Tools and Documentation",
            description: "Explore our extensive library of documentation, tutorials, and guides to help you get the most out of Gunbot.",
            "resources": [
                {
                    "title": "Custom Strategies Examples",
                    "description": "Overview of code examples for custom trading strategies. This section provides examples of custom strategies that you can use as a reference or starting point for building your own strategies.",
                    "link": "https://www.gunbot.com/support/docs/custom-strategies/example-strategies/overview/",
                    "linkText": "Strategy code examples"
                  },
                {
                    "title": "What, Custom Strategies?",
                    "description": "Understand the fundamentals of custom strategies in Gunbot. This doc provides an overview of how custom strategies work and what you should consider about their runtime environment.",
                    "link": "https://www.gunbot.com/support/docs/custom-strategies/what-are-custom-strategies/",
                    "linkText": "What are custom strategies"
                  },
                  {
                    "title": "Methods and Modules",
                    "description": "Learn about the methods and modules available for custom strategies. This documentation covers the various functions and modules you can use to build and enhance your custom trading strategies.",
                    "link": "https://www.gunbot.com/support/docs/custom-strategies/methods-modules/",
                    "linkText": "Methods and modules"
                  },
                  {
                    "title": "Market Data",
                    "description": "This guide explains the different types of market data that's readily available to use in custom strategies.",
                    "link": "https://www.gunbot.com/support/docs/custom-strategies/market-data/",
                    "linkText": "Available market data"
                  },
                  {
                    "title": "Visualize Strategy Targets",
                    "description": "A guide on how to visualize strategy targets. Learn how to create visual representations of your strategy targets to better understand their performance and make necessary adjustments.",
                    "link": "https://www.gunbot.com/support/docs/custom-strategies/visualize-strategy-targets/",
                    "linkText": "Custom visual targets"
                  },
                  {
                    "title": "Display Custom Stats",
                    "description": "Instructions on displaying custom statistics for strategies. This documentation helps you understand how to set up and display custom statistics that are relevant to your trading strategies.",
                    "link": "https://www.gunbot.com/support/docs/custom-strategies/display-custom-stats/",
                    "linkText": "Custom strategy stats"
                  },
                  {
                    "title": "AutoConfig Settings Handling",
                    "description": "Detailed guide on controlling trading settings with autoconfig. Learn how to manage and configure pair settings automatically using the autoconfig module.",
                    "link": "https://www.gunbot.com/support/guides/trading-logic-and-optimization/autoconfig-control-pair-settings/",
                    "linkText": "AutoConfig settings handling"
                  },
                  {
                    "title": "AutoConfig Pair Management",
                    "description": "Guide to adding and removing pairs using autoconfig. This documentation explains how to automate the process of adding and removing trading pairs based on specific criteria.",
                    "link": "https://www.gunbot.com/support/guides/trading-logic-and-optimization/autoconfig-adding-removing-pairs/",
                    "linkText": "AutoConfig pair management"
                  },
                  {
                    "title": "Gunbot Guru GPT",
                    "description": "Too lazy to read docs? Use this GPT that has access to all Gunbot docs and many code examples.",
                    "link": "https://chatgpt.com/g/g-9Q96nWnrs-gunbot-guru",
                    "linkText": "Gunbot Guru GPT"
                  },
                  {
                    "title": "Visual Studio Code extension",
                    "description": "Use our VS Code extension with snippets for all supported methods and data points.",
                    "link": "https://marketplace.visualstudio.com/items?itemName=gunbot-trading-bot.gunbot-custom-trading-strategy-snippets",
                    "linkText": "VS Code Extension"
                  },
                  {
                    "title": "REST API",
                    "description": "Detailed documentation for our REST API, which allows you to run Gunbot completely headless and integrate it with your own tools.",
                    "link": "https://www.gunbot.com/support/docs/rest-api/gunbot-api-intro/",
                    "linkText": "Supported timeframes"
                  },
            ]
        },
    },
    hero: {
        logoAlt: "Gunbot Logo"
    },
    cta: {
        text: "Built something cool to offer to Gunbot users?",
        primaryLinkText: "Get in touch",
        primaryLinkUrl: "/contact/",
        faqLinkTitle: "Get in touch",
        faqLinkUrl: "https://www.gunbot.com/contact/",
    },
};

export default defaultContent;
